import { createClient } from '@supabase/supabase-js';

// Get your Supabase URL and public anon key from your environment variables.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Create and export a single, shared Supabase client instance for your entire app.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);